/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_PainInputs */

const en_us2_workout_after_pain = /** @type {(inputs: Workout_After_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did any exercise hurt?`)
};

const pt_br2_workout_after_pain = /** @type {(inputs: Workout_After_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentiu dor em algum exercício?`)
};

const es_419_workout_after_pain = /** @type {(inputs: Workout_After_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Te dolió algún ejercicio?`)
};

const pt_pt2_workout_after_pain = /** @type {(inputs: Workout_After_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentiste dor em algum exercício?`)
};

const fr_fr2_workout_after_pain = /** @type {(inputs: Workout_After_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un exercice t'a fait mal ?`)
};

const de_de2_workout_after_pain = /** @type {(inputs: Workout_After_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat eine Übung wehgetan?`)
};

const it_it2_workout_after_pain = /** @type {(inputs: Workout_After_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai sentito dolore in qualche esercizio?`)
};

/**
* | output |
* | --- |
* | "Did any exercise hurt?" |
*
* @param {Workout_After_PainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain = /** @type {((inputs?: Workout_After_PainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_PainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain(inputs)
	if (locale === "es-419") return es_419_workout_after_pain(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain(inputs)
	return en_us2_workout_after_pain(inputs)
});
export { workout_after_pain as "workout-after.pain" }